import { z } from "zod";
import { CompanyTypeArray } from "../company/types.js";
export const SiretLookupSiretSchema = z.string().regex(/^\d{14}$/);
export const SiretLookupResultSchema = z.object({
    legalName: z.string(),
    streetAddress: z.string(),
    streetAddress2: z.string().nullable(),
    zipCode: z.string(),
    city: z.string(),
    apeCode: z.string(),
    apeLabel: z.string().nullable(),
    vatId: z.string(),
    companyType: z.enum(CompanyTypeArray).nullable(),
    isClosed: z.boolean(),
    /**
     * OR de `statut_diffusion` (unité légale) et `statut_diffusion_etablissement`
     * (établissement) côté DINUM ("P" = diffusion partielle) — informatif
     * seulement, n'alimente aucun gate (#1042).
     */
    isDiffusionRestricted: z.boolean(),
});
export const SiretLookupResponseSchema = z.discriminatedUnion("found", [
    z.object({ found: z.literal(true), data: SiretLookupResultSchema }),
    z.object({ found: z.literal(false) }),
]);
//# sourceMappingURL=siretLookup.types.js.map